
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Classical Conclave</h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm employee-sports hrishikesh-karmarkar section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2>Dilruba Playing A Unique Gift Of <span > Musical Tunes</span></h2>
            <p>(Dilruba was invented some 300 years ago by Guru Gobind Singh (10th Sikh Guru), who inspired it with)</p>
            <p>Taus (an ancient and heavy instrument)</p>
            <p>By</p>
            <p>Hrishikesh Karmarkar</p>
        </div>
        <div class="row mt-5">
            <div class="col-lg-8">
                <div class=" text-justify">
                    <h2 class="head-lea">HRISHIKESH KARMARKAR <span class="small-sm">4 JULY 2020 </span></h2>
                    <p>Hrishikesh Karmarkar Engineering 4th year student.</p>
                    <p>Started learning vocals firstly from mother .Took basic lessons from pt. Jayantji Indurkar,
                        Formally started learning classical music vocal from Pt. Shubhasji Kashalkar. He is currently
                        completing his Visharad Pratham varsha. He started practicing dilruba at home learning from
                        YouTube videos , later he got the Guidance from Shri Shirishji Bhalerao( Radio staff artist) and
                        currently learning dilruba solo from him.</p>
                    <p>He was first in Classical Music and Classical instrumental (Dilruba) in Nagpur university and
                        represented Nagpur University in State level and Zonal Level for 2 times. He won 1st prize in
                        Classical Instrumental (Dilruba) and 2nd prize in Classical vocal at Zonal level youth festival
                        held at Gwalior</p>
                    <p>He Won 2nd prize at National Level Youth festival held at Noida in Classical Vocal category. Was
                        among Top 15 contestants of Zee Sangeet Samrat for playing dilruba and got wide appreciation.
                    </p>
                </div>
            </div>

            <div class="col-md-4">
                <div class="image-effect-3">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/hrishikesh_karmarkar.webp"
                        alt="GHRSCF">
                </div>
            </div>
        </div>

        <div class="border-line-sm"></div>
        <div class="row">
            <div class="col-lg-8">

                <h6 class="fw-bold">LET’S MEET THEN.</h6>
                <h6 class="fw-bold">G.H. RAISONI SPORTS & CULTURAL FOUNDATION ORGANIZES - ONLINE SESSION</h6>
                <h6 class="fw-bold">TOPIC : DILRUBA PLAYING A UNIQUE GIFT OF MUSICAL TUNES (DILRUBA WAS INVENTED SOME
                    300 YEARS AGO BY GURU GOBIND SINGH (10TH SIKH GURU), WHO INSPIRED IT WITH TAUS (AN ANCIENT AND HEAVY
                    INSTRUMENT)</h6>
                <p>Artist: Hrishikesh Karmarkar (One of the 7 young engineering students of Avan Nagpur's budding young
                    artists)</p>
                <p>Date : Saturday, 4<sup>th</sup> July 2020</p>
                <p>Time : 7:00 Pm</p>
                <p>Venue : Your Home at your Mobile</p>

                <h6 class="fw-bold">NOTE - LOGIN TO YOUR FACEBOOK ACCOUNTS 10 MINS BEFORE THE SESSION</h6>
                <p>Link: <a href="https://facebook.com/sgrkf/live" target="_blank">https://facebook.com/sgrkf/live</a>
                </p>

            </div>
            <div class="col-md-4">
                <div class="image-effect-3">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/hk.webp"
                        alt="GHRSCF">
                </div>
            </div>
        </div>

        <div class="border-line-sm"></div>

        <div class="row">
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">You can also visit</h4>
                            </div>
                        </div>
                        <div class="col-md-4 text-end">
                            <a href="videogallery" target="_blank" class="btn button--effect-1"><span>
                                    YouTube link</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                            </a>
                        </div>
                    </div>
                    <iframe
                        src="https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Fsgrkf%2Fvideos%2F640995126504577%2F&show_text=false&width=267&t=0"
                        width="100%" height="230" style="border:none;overflow:hidden" scrolling="no" frameborder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>
                    <!-- <iframe width="100%" height="230" src="htttps://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Fsgrkf%2Fvideos%2F640995126504577%2F&show_text=false&width=267&t=0"  frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>  -->
                </div>
            </div>

        </div>

    </div>
</section>
